const TypingLoader: React.FC = () => {
    return(
        <div className="typing d-flex align-items-center">
            <div className="loader">
              <div className="orbit">
                <div className="dot"></div>
              </div>
            </div>
            Planning: finding the best approach to find the answer.
          </div>
    );
};
export default TypingLoader